import React from "react";
import "./Card2.css";

const Card2 = (props) => {
  return (
    <div className="Card2">
      <img src={props.Image} alt="" />
      <div className="texting">
        <h2>{props.Title}</h2>
        <p>{props.Content}</p>
      </div>
    </div>
  );
};

export default Card2;
